import * as R from 'ramda'

export default R.pipe(R.length, R.lte(1))
